import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: 'What exactly is cabinet refacing?',
  answer: "Cabinet refacing is a 'surgical' remodel. We keep your existing cabinet boxes (the structure) but replace all the visible parts: the doors, drawer fronts, and hardware. We then apply a matching premium wood veneer to the exterior of the boxes so the entire kitchen looks brand new."
}, {
  question: 'How long does the installation take?',
  answer: "Most of our projects are completed in just 1 to 2 days. Because we aren't tearing out walls or flooring, we can work quickly and efficiently without the typical construction delays."
}, {
  question: 'Can I change the style of my doors?',
  answer: "Absolutely. You aren't just changing the color; you're changing the architecture. You can switch from outdated raised panels to modern Shaker, Slab, or any of our premium styles."
}, {
  question: 'Do I need to empty my cabinets before you arrive?',
  answer: "In most cases, no! Since we aren't removing the cabinet boxes, your dishes and pantry items can stay right where they are. This is one of the biggest conveniences of refacing over a full remodel."
}, {
  question: 'Is refacing as durable as new cabinets?',
  answer: 'Yes. We use high-pressure bonding for our veneers and furniture-grade wood for our doors. The finished product is indistinguishable from high-end new cabinetry and is built to withstand daily kitchen use for decades.'
}, {
  question: 'What areas do you serve?',
  answer: 'We primarily serve Bowie, MD and the surrounding areas in Maryland, Virginia, and West Virginia. If you are outside these areas, we offer remote quoting via photo uploads.'
}];
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`border-b-2 border-charcoal/10 transition-colors duration-500 ${isOpen ? 'bg-charcoal/[0.02]' : ''}`} data-id="element-264">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 md:py-8 flex justify-between items-center text-left hover:bg-charcoal/[0.03] transition-colors px-6" data-id="element-265">
        <div className="flex gap-6 items-center" data-id="element-266">
          <span className="text-espresso font-serif italic text-lg opacity-40" data-id="element-267">
            0{index + 1}
          </span>
          <span className="text-lg md:text-xl font-bold uppercase tracking-tight" data-id="element-268">
            {question}
          </span>
        </div>
        <div className={`w-8 h-8 border border-charcoal/20 flex items-center justify-center transition-transform duration-500 ${isOpen ? 'rotate-180 border-espresso' : ''}`} data-id="element-269">
          {isOpen ? <MinusIcon className="w-4 h-4 text-espresso" data-id="element-270" /> : <PlusIcon className="w-4 h-4 text-charcoal" data-id="element-271" />}
        </div>
      </button>
      <AnimatePresence data-id="element-272">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-273">
            <div className="pb-8 pl-16 pr-6 text-charcoal/60 leading-relaxed max-w-3xl text-sm md:text-base" data-id="element-274">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQPage() {
  return <Layout data-id="element-275">
      <div className="py-20 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-276">
        <div className="max-w-7xl mx-auto" data-id="element-277">
          <h1 className="text-5xl md:text-7xl font-bold mb-6" data-id="element-278">
            Common <br data-id="element-279" />
            <span className="italic font-serif font-normal text-espresso" data-id="element-280">
              Questions
            </span>
          </h1>
          <p className="text-lg text-charcoal/60 max-w-2xl leading-relaxed" data-id="element-281">
            Everything you need to know about transforming your kitchen without
            the demolition headache.
          </p>
        </div>
      </div>

      <section className="py-20 px-6 bg-white" data-id="element-282">
        <div className="max-w-4xl mx-auto border-t-2 border-charcoal/10" data-id="element-283">
          {faqs.map((faq, index) => <FAQItem key={index} index={index} {...faq} data-id="element-284" />)}
        </div>
      </section>

      <section className="py-24 px-6 bg-espresso text-alabaster text-center border-t-3 border-charcoal" data-id="element-285">
        <div className="max-w-2xl mx-auto" data-id="element-286">
          <h2 className="text-4xl font-bold mb-6" data-id="element-287">Still have questions?</h2>
          <p className="mb-10 text-alabaster/80" data-id="element-288">
            Our specialists are ready to help you plan your transformation.
          </p>
          <a href="/get-quote" className="inline-block bg-charcoal text-alabaster px-10 py-5 font-bold uppercase tracking-widest hover:bg-white hover:text-charcoal transition-all" data-id="element-289">
            Speak with an Expert
          </a>
        </div>
      </section>
    </Layout>;
}